export interface PendoEventMap {
    'Message Hub Use Suggestion': { team_id: number; group_id: string | null; contact_id: number };
    'Message Hub Inbox Navigation': { inbox: string; team_id: number };
    'Message Hub Send': { inbox: string; team_id: number; group_id: string | null; contact_id: number };
    'Message Hub Suggested Reply Sent': { inbox: string; team_id: number; group_id: string | null; contact_id: number };
}

export type PendoEvent = {
    [K in keyof PendoEventMap]: [name: K, metadata: PendoEventMap[K]];
}[keyof PendoEventMap];

export const pendoEvent = <K extends keyof PendoEventMap>(
    name: K,
    metadata: PendoEventMap[K]
): [K, PendoEventMap[K]] => [name, metadata];

// window.pendo is absent in dev / disabled sessions; the agent stub queues calls made before it loads.
export const trackPendoEvent = ([name, metadata]: PendoEvent): void => {
    window.pendo?.track(name, metadata);
};
